function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Vue from 'vue';
import { VCheckbox } from 'vuetify/lib';
import FormMixin from '../form.mixin';

var Checkbox = /*#__PURE__*/function () {
  function Checkbox() {
    _classCallCheck(this, Checkbox);
  }

  _createClass(Checkbox, null, [{
    key: "register",
    value: function register() {
      Vue.component('roche-checkbox', {
        template: "<v-checkbox\n        :ripple=\"false\"\n        v-bind=\"bind\"\n        v-on=\"$listeners\"\n        v-model=\"model\"\n        @change=\"$emit('input', $event)\">\n        <template v-slot:label>\n          <slot></slot>\n        </template>\n      </v-checkbox>",
        mixins: [FormMixin],
        components: {
          VCheckbox: VCheckbox
        },
        mounted: function mounted() {
          _toConsumableArray(this.$el.querySelectorAll('label a')).forEach(function (el) {
            var termClickHandler = function termClickHandler(event) {
              event.stopPropagation();
              event.preventDefault();
              window.open(el.href, el.target);
              return false;
            };

            el.addEventListener('click', termClickHandler);
            el.addEventListener('touchstart', termClickHandler);
          });
        }
      });
    }
  }]);

  return Checkbox;
}();

export default Checkbox;